'use strict';
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$0024 from "./app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$() {
  this.aF9 = null;
  this.aFm = null;
  this.aFe = null;
  this.aFf = false;
  this.aFk = null;
  this.aFl = false;
  this.aFa = null;
  this.aFb = false;
  this.aFi = null;
  this.aFj = false;
  this.aFg = null;
  this.aFh = false;
  this.aFc = null;
  this.aFd = false;
  $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ = this;
  this.aF9 = $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$0024.$m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$();
  this.aFm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$0024.$m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumber$());
}
export { $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ as $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ };
$p = $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$;
/** @constructor */
function $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$() {
}
export { $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ as $h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ };
$h_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aF9;
});
$p.eO = (function() {
  return this.aFm;
});
$p.b9 = (function() {
  if ((!this.aFf)) {
    this.aFe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aFf = true;
  }
  return this.aFe;
});
$p.b3 = (function() {
  if ((!this.aFl)) {
    this.aFk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aFl = true;
  }
  return this.aFk;
});
$p.aG = (function() {
  if ((!this.aFb)) {
    this.aFa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aFb = true;
  }
  return this.aFa;
});
$p.az = (function() {
  if ((!this.aFj)) {
    this.aFi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aFj = true;
  }
  return this.aFi;
});
$p.aY = (function() {
  if ((!this.aFh)) {
    this.aFg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aFh = true;
  }
  return this.aFg;
});
$p.bNf = (function() {
  if ((!this.aFd)) {
    this.aFc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "PO Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aFd = true;
  }
  return this.aFc;
});
var $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$, "app.data.PurchaseOrderContractData$package$PurchaseOrderNumberForm$", ({
  EO: 1,
  N: 1
}));
export { $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ as $d_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ };
var $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$;
function $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$() {
  if ((!$n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$)) {
    $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ = new $c_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$();
  }
  return $n_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$;
}
export { $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ as $m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$ };
//# sourceMappingURL=app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number-Form$.js.map
